import { reduce } from "et3-type-guards";
import ReactAudioPlayer from "react-audio-player";
import { E_MESSAGE_DELETION_STATUS, TMessage } from "../../../../../Types";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../core/et3-text";
import Et3Image from "../../../../../core/et3-Image";
import ET3Div from "../../../../../core/et3-div";

const MessageType = withLiteObserverAndTheme<{
  messages: TMessage;
}>((props) => {
  const { theme, messages } = props;
  const { colors, unitY } = theme;
  const message = reduce(() => messages, {
    sentOn: "",
    message: "",
    senderId: 0,
    messageId: 0,
    messageType: "text",
    recipientId: 0,
    messageObject: {
      message: "",
      messageType: "picture"
    },
    isDeleted: E_MESSAGE_DELETION_STATUS.NOT_DELETED,
    deletedOn: "",
    reactions: [],
    hasReactionHistory: false
  });

  return (
    <ET3Div
      isScrollable={false}
      withShadow={false}
      isExtendable={true}
      height={0}
      width={500}
      color={colors.all.transparent}
      fDirection="column"
      justifyContent={"center"}
      alignItems={"flex-start"}
      style={{}}
      onClick={() => {}}
    >
      {message.messageType === "picture" ? (
        <Et3Image
          type="ONLINE"
          alt={"Message"}
          imageName={`${message.messageObject.message}`}
          size={100}
          onClick={() => {}}
          style={{
            maxHeight: 100 * unitY
          }}
        />
      ) : message.messageType === "voice" ? (
        <ReactAudioPlayer
          src={`${message.messageObject.message}`}
          autoPlay={false}
          controls
        />
      ) : (
        <Et3Text
          fontFamily={"BOLD"}
          fontSize={15}
          text={message.message}
          isSpan={false}
          color={colors.all.white}
          style={{
            wordWrap: "break-word"
          }}
        />
      )}
    </ET3Div>
  );
});
export default MessageType;
